<template>
  <Loader style="z-index:10000" v-if="loader" />
  <div class="card">
    <DataTable :value="items" :paginator="true" :rows="100" :filters="filters"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 20, 50, 100, 500]" responsiveLayout="scroll"
      currentPageReportTemplate="{first} a {last} di {totalRecords}">
      <template #header>
        <div class="table-header flex justify-content-between">
          <div class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
          </div>
          <div>
            <Button @click="dialogNewPrice = true" label="Aggiungi Prezzo" icon="pi pi-plus" iconPos="left"
              class="p-button-success" />
          </div>
        </div>
      </template>
      <template #empty>
        <div class="text-center">Nessun dato trovato.</div>
      </template>
      <Column field="competenza" header="Competenza" :sortable="true">
        <template #body="{ data, field }">
          {{ formatDate(data[field]) }}
        </template>
      </Column>
      <Column field="prezzo" header="Prezzo" :sortable="true"></Column>
      <Column field="tipologia" header="Tipo" :sortable="true">
        <template #body="{ data, field }">
          {{ data[field] == 'E' ? 'Energia' : 'Gas' }}
        </template>
      </Column>
    </DataTable>
  </div>
  <Dialog v-model:visible="dialogNewPrice" :style="{ width: '800px' }" header="Nuovo Prezzo" :modal="true"
    class="p-fluid">
    <div class="grid">
      <div class="field col-4">
        <label>Prezzo</label>
        <InputText type="number" v-model.trim="newPrice.prezzo" required="true" autofocus
          :class="{ 'p-invalid': validationErrors.prezzo && submitted }" />
        <div v-show="validationErrors.prezzo && submitted" class="p-error">Campo richiesto.</div>
      </div>
      <div class="field col-4">
        <label>Competenza</label>
        <Calendar v-model="newPrice.competenza" :showIcon="true" :manualInput="false" dateFormat="dd-mm-yy"
          class="inputfield w-full" />
        <div v-show="validationErrors.date && submitted" class="p-error">Data esistente o non valida.</div>
      </div>
      <div class="field col-4">
        <label>Tipo</label>
        <Dropdown v-model="newPrice.tipo" :options="newPrice.tipi" optionLabel="name" optionValue="code"
          class="inputfield w-full" />
      </div>
    </div>

    <template #footer>
      <Button label="Salva" icon="pi pi-check" class="p-button-success mr-2" @click="saveNewPrice" />
      <Button label="Annulla" icon="pi pi-times" class="p-ml-auto p-button-danger" @click="dialogNewPrice = false" />
    </template>
  </Dialog>


</template>

<script>
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import moment from 'moment';
import { useToast } from "primevue/usetoast";


export default {
  components: {
    Loader
  },
  setup() {
    const toast = useToast();
    const loader = ref(false)
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    const items = ref([]);
    const dialogNewPrice = ref(false)
    const newPrice = ref({
      'competenza': moment().startOf('month').toDate(),
      'competenza_': '',
      'prezzo': 0,
      'tipo': 'E',
      'tipi': [{ name: 'Energia', code: 'E' }, { name: 'Gas', code: 'G' }]
    })
    const validationErrors = ref({})
    const submitted = ref(false)

    onMounted(() => {
      getData()
    })
    const getData = () => {
      loader.value = true
      service.getInternalPurchasePrice()
        .then((res) => {
          items.value = res.items
        }).finally(() => {
          loader.value = false
        })
    }

    const saveNewPrice = () => {
      submitted.value = true
      if (validateNewPrice()) {
        loader.value = true
        newPrice.value.competenza_ = moment(newPrice.value.competenza).format('YYYY-MM-DD')
        service.saveInternalPurchasePrice(newPrice.value)
          .then((res) => {
            if (res.success) {
              toast.add({ severity: 'success', summary: 'Successo', detail: 'Prezzo aggiunto' });
              dialogNewPrice.value = false
              getData()
            } else {
              toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Errore nel salvataggio' });
            }
          }).finally(() => {
            loader.value = false
          })
      }
    }


    const validateNewPrice = () => {
      validationErrors.value = {}

      if (newPrice.value.prezzo > 0) {
        delete validationErrors.value['prezzo'];
      } else {
        validationErrors.value['prezzo'] = true;
      }

      if (items.value.some(el => el.competenza.includes(moment(newPrice.value.competenza).format('YYYY-MM-DD')) && newPrice.value.tipo == el.tipologia)) {
        validationErrors.value['date'] = true;
      } else {
        delete validationErrors.value['date'];
      }

      return !Object.keys(validationErrors.value).length;
    }


    return {
      formatDate,
      items,
      loader,
      service,
      filters,
      getData,
      newPrice,
      saveNewPrice,
      dialogNewPrice,
      validationErrors,
      submitted
    }
  }
}
</script>

<style scoped></style>
